import { useParams } from "react-router-dom";
import withAuth from "../../components/auth";
import { injectIntl } from "react-intl";

function ButtonEdit(props) {
    let { id } = useParams();  
    return (
        <>
            <edit-system-buttom id={id} />
        </>
    );
}

export default injectIntl(withAuth(ButtonEdit));